module.exports = __webpack_public_path__ + "img/google_social.45dff0ba.svg";